<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="文章标题">
              <j-search-select-tag
                placeholder="请输入文章标题"
                v-model="queryParam.articleId"
                dict="article,title,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="查看者姓名">
              <j-search-select-tag
                placeholder="请输入查看者姓名"
                v-model="queryParam.viewerId"
                dict="sys_user,realname,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="文章作者姓名">
              <j-search-select-tag
                placeholder="请输入文章作者姓名"
                v-model="queryParam.authorId"
                dict="sys_user,realname,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('文章浏览日志')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <articleViewLog-modal ref="modalForm" @ok="modalFormOk"></articleViewLog-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ArticleViewLogModal from './modules/ArticleViewLogModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import TeacherClassModal from '../teacherClass/modules/TeacherClassModal'


  export default {
    name: "ArticleViewLogList",
    mixins:[JeecgListMixin],
    components: {
      ArticleViewLogModal,
      JSearchSelectTag
    },
    data () {
      return {
        description: '文章浏览日志管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
		   {
            title: '文章标题',
            align:"center",
            dataIndex: 'articleId_dictText'
           },
		   {
            title: '查看者名称',
            align:"center",
            dataIndex: 'viewerId_dictText',
            customRender: (text) => {
            return text ? text : '微信用户';
         }
           },
		   // {
       //      title: '查看者名称',
       //      align:"center",
       //      dataIndex: 'viewerName'
       //     },
		   {
            title: '文章作者名称',
            align:"center",
            dataIndex: 'authorId_dictText'
           },
		   // {
       //      title: '1.浏览记录 2.展现记录（量）',
       //      align:"center",
       //      dataIndex: 'type'
       //     },
          {
               title: '浏览时间',
               align:"center",
               dataIndex: 'createTime'
              },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/articleViewLog/list",
          delete: "/articleViewLog/delete",
          deleteBatch: "/articleViewLog/deleteBatch",
          exportXlsUrl: "/articleViewLog/exportXls",
          importExcelUrl: "/articleViewLog/importExcel",
       },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>